function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.3333 6.66667H10.6667C9.93028 6.66667 9.33332 7.26362 9.33332 8V13.3333C9.33332 17.0152 12.3181 20 16 20C19.6819 20 22.6667 17.0152 22.6667 13.3333V8C22.6667 7.26362 22.0697 6.66667 21.3333 6.66667ZM10.6667 4C8.45752 4 6.66666 5.79086 6.66666 8V13.3333C6.66666 18.488 10.8453 22.6667 16 22.6667C21.1546 22.6667 25.3333 18.488 25.3333 13.3333V8C25.3333 5.79086 23.5425 4 21.3333 4H10.6667Z",
  fill: "#21D170"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33334 10.6667C1.33334 8.45761 3.1242 6.66675 5.33334 6.66675H9.33334V17.3334H6.66668C3.72116 17.3334 1.33334 14.9456 1.33334 12.0001V10.6667ZM5.33334 9.33342H6.66668V14.6667C5.19392 14.6667 4.00001 13.4728 4.00001 12.0001V10.6667C4.00001 9.93037 4.59696 9.33342 5.33334 9.33342Z",
  fill: "#21D170"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.6667 10.6667C30.6667 8.45761 28.8758 6.66675 26.6667 6.66675H22.6667V17.3334H25.3333C28.2789 17.3334 30.6667 14.9456 30.6667 12.0001V10.6667ZM26.6667 9.33342H25.3333V14.6667C26.8061 14.6667 28 13.4728 28 12.0001V10.6667C28 9.93037 27.4031 9.33342 26.6667 9.33342Z",
  fill: "#21D170"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 20C15.2636 20 14.6667 20.597 14.6667 21.3333V25.3333H12C11.2636 25.3333 10.6667 25.9303 10.6667 26.6667C10.6667 27.403 11.2636 28 12 28H20C20.7364 28 21.3333 27.403 21.3333 26.6667C21.3333 25.9303 20.7364 25.3333 20 25.3333H17.3333V21.3333C17.3333 20.597 16.7364 20 16 20Z",
  fill: "#21D170"
});

var SvgRanking = function SvgRanking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRanking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ranking.472c3969.svg";
export { ForwardRef as ReactComponent };